<template>
  <basic-card>
    <template slot="header">
      Cash-events
    </template>

    <simple-list object-name="cashEvent" query-store-name="cashEvent" :columns="columns"/>

  </basic-card>
</template>

<script>
import BasicCard from "../components/layout/BasicCard";
import FilterForm from "../components/filters/FilterForm";
import QueryUtils from "../utils/QueryUtils";
import CollapsibleContent from "../components/CollapsibleContent";
import DataTable from "../components/table/DataTable";
import {mapGetters} from "vuex";
import SimpleButton from "../components/button/SimpleButton";
import Empty from "../components/layout/Empty";
import SimpleHorizontalLayout from "../components/layout/SimpleHorizontalLayout";
import FormWrapper from "../components/form/FormWrapper";
import FormSelectInput from "../components/form/FormSelectInput";
import FormTextInput from "../components/form/FormTextInput";
import SimpleList from "../components/lists/SimpleList";

export default {
  name: "CashEventsView",
  components: {
    SimpleList,
    FormTextInput,
    FormSelectInput,
    FormWrapper,
    SimpleHorizontalLayout, Empty, SimpleButton, DataTable, CollapsibleContent, FilterForm, BasicCard
  },
  computed: {
    ...mapGetters({"account": "banking/account",
    parties: "parties/parties"})
  },
  data() {
    return {
      columns: [
        {
          caption: "Id",
          datum: d => d.id.substr(0, 5)
        },
        {
          caption: "Type",
          datum: d => d.type
        },
        {
          caption: "Status",
          datum: d => d.status ?? "N/A"
        },
        {
          caption: "Counterparty",
          datum: d => this.parties.find(party => party.id == d.counterparty)?.displayName ?? "N/A"
        },
        {
          caption: "Transaction reference",
          datum: d => d.transactionReference
        },
        {
          caption: "Secondary trn. reference",
          datum: d => d.secondaryTransactionReference
        },
        {
          caption: "Planned date",
          datum: d => this.$formats.formatDate(d.timestamp)
        },
        {
          caption: "Realization date",
          datum: d => d.realization != null ? this.$formats.formatDate(d.realization) : "N/A"
        },
        {
          caption: "Source",
          datum: d => d.source
        },
        {
          caption: "Amount",
          datum: d => this.$formats.formatAmount(d.amount / 1000000)
        },
        {
          caption: "CCY",
          datum: d => d.currency
        },
        {
          caption: "Account",
          datum: d => this.account(d.account)?.name ?? "N/A"
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>